import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchDetail, fetchUpdate } from "@/api/PMS/communityPartyBuilding/activityType";
export default {
  props: ["keyValue", "showDialog"],
  data: function data() {
    var checkActivityTypeName = function checkActivityTypeName(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入活动类型名称"));
      } else if (value.length > 20) {
        return callback(new Error("活动类型名称不能超过20个字"));
      } else {
        callback();
      }
    };

    return {
      rules: {
        activityTypeName: [{
          validator: checkActivityTypeName,
          trigger: "blur"
        }]
      },
      isBtnDisabled: false,
      childData: {},
      appType: 0
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.appType = parseInt(appType);
    }

    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.isBtnDisabled = false;
      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handleRemarkInput: function handleRemarkInput(val) {
      if (val.length > 99) {
        this.$message({
          message: "备注的最大长度不能超过100个字符",
          type: "warning"
        });
      }

      this.$set(this.childData, "remark", val.slice(0, 100));
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.isBtnDisabled = true;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            _this2.childData.id = _this2.keyValue;
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit("handCancle", true);

                _this2.Alert({
                  alertType: "update"
                });
              } else {
                _this2.isBtnDisabled = false;
              }
            }).catch(function (err) {
              _this2.isBtnDisabled = false;
            });
          } else {
            _this2.childData.appType = _this2.appType;
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit("handCancle", true);

                _this2.Alert({
                  alertType: "add"
                });
              } else {
                _this2.isBtnDisabled = false;
              }
            }).catch(function (err) {
              _this2.isBtnDisabled = false;
            });
          }
        } else {
          _this2.isBtnDisabled = false;

          _this2.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", true);
    }
  }
};